import { render, staticRenderFns } from "./MibAd.vue?vue&type=template&id=cd3a20a0&scoped=true&"
import script from "./MibAd.vue?vue&type=script&lang=js&"
export * from "./MibAd.vue?vue&type=script&lang=js&"
import style0 from "./MibAd.vue?vue&type=style&index=0&id=cd3a20a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3a20a0",
  null
  
)

export default component.exports